import { Doms } from "../../../components/doms.js";
import { LoadingDot } from "../../../components/loading-dot.js";
import { LoadingLine } from "../../../components/loading-line.js";
import { ModalController } from "../../../components/modal/controller.js";
import { USER_OPTIONS } from "../../../config/constants.js";
import { UserPrivateAuthController } from "../auth/controller.js";
import { ClearFields, ClearFormErrors, GetFormData, ShowErrors } from "./dom.js";
import { UserPrivateAccountModel } from "./model.js";
import { UserPrivateAccountStorage } from "./storage.js";
import { UserPrivateAccountSubscriptionsController } from "./subscriptions/controller.js";
import { UserPrivateAccountView } from "./view.js";

export class UserPrivateAccountController {
  constructor() {
    this.view = new UserPrivateAccountView();
    this.model = UserPrivateAccountModel.getInstance();
    this.loading = LoadingLine.getInstance();
    this.auth = UserPrivateAuthController.getInstance();
    this.subscriptions = UserPrivateAccountSubscriptionsController.getInstance();
    this.storage = UserPrivateAccountStorage.getInstance();
    this.doms = new Doms();
  }

  loadMain(_user) {
    document.getElementById('user-content').innerHTML = this.view.renderHeader(_user) + this.view.renderForm(_user);
    this.doms.addClass('btn-account', 'active');
    APICRUD.Location.Selector_LoadStates('account-idState', _user.idCountry, _user.idState);
    APICRUD.Location.Selector_LoadCities('account-idCity', _user.idState, _user.idCity);
    APICRUD.Common.Select.SetData('account-occupation', _user.occupation, USER_OPTIONS.Cargos);
    if (!_user.permalink) {
      this.doms.setValue('account-permalink', APICRUD.Common.GetPermalink(_user.name));
    }
    this.checkPermalink(this.doms.getValue('account-permalink'));
    history.pushState({}, '', `/user/account`);
    this.loading.hide();
    app.userPrivateController.account.checkSubscription();

  }

  async getTotalActivePublications() {
    try {
      let total = 0;
      let inmuebles = await app.userPrivateController.inmuebles.model.read()
      total += inmuebles.data.length;
      let productos = await app.userPrivateController.productos.model.read()
      total += productos.data.length;
      let servicios = await app.userPrivateController.servicios.model.read()
      total += servicios.data.length;
      let maquinaria = await app.userPrivateController.maquinaria.model.read()
      total += maquinaria.data.length;
      return total;
    } catch (error) {
      console.error('getTotalActivePublications: ', error);
      throw new Error(0);
    }
  }

  isPublished(_idcod) {
    return new Promise(async (resolve, reject) => {
      let inmuebles = await app.userPrivateController.inmuebles.model.read()
      inmuebles.data.forEach(p => { if (p.idcod == _idcod) resolve(true); });
      let productos = await app.userPrivateController.productos.model.read()
      productos.data.forEach(p => { if (p.idcod == _idcod) resolve(true); });
      let servicios = await app.userPrivateController.servicios.model.read()
      servicios.data.forEach(p => { if (p.idcod == _idcod) resolve(true); });
      let maquinaria = await app.userPrivateController.maquinaria.model.read()
      maquinaria.data.forEach(p => { if (p.idcod == _idcod) resolve(true); });
      resolve(false);
    })
  }

  async canPublish(_publish, _idcod) {
    try {
      let published = await this.getTotalActivePublications();
      if (_publish === true) {
        // Si ya estaba publicada, debe poder guardarla
        if (await this.isPublished(_idcod)) {
          return true;
        }

        // Si no estaba publicada, calcula segun la quota
        if (Number(published) < this.storage.getPublishLimit()) {
          return true;
        }

        let modal = new ModalController('Ha llegado al límite de publicaciones', this.view.renderPublishLimit());
        modal.show();
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.error('canPublish: ', error);
      throw error;
    }
  }

  save() {
    let newData = GetFormData();

    ClearFormErrors();

    let validation = this.model.validate(newData);

    if (validation === true) {
      this.doms.setHTML('account-status', 'Guardando...');

      window.localStorage.removeItem('user-' + app.userPrivateController.userData.idcod);

      this.loading.show();
      this.auth.sessionSetData(newData)
        .then(() => {
          window.localStorage.removeItem('user-data');
          this.doms.setHTML('account-status', 'Datos guardados.');
          APICRUD.ClearCache('user-' + newData.idcod);
          this.auth.sessionGetData()
            .then(() => {
              new ModalController('Confirguración de mi cuenta', '¡Datos actualizados con éxito!').show();
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            })
        })
        .catch(_response => {
          this.doms.setHTML('account-status', _response.message || 'Error');

          if (_response.message.indexOf('VS01') > -1) {
            APICRUD.Auth.Logout('/');
          }
        })
        .finally(() => {
          this.loading.hide();
        })
    } else {
      ShowErrors(validation);
    }
  }

  clearFields() {
    ClearFields();
  }

  // plan 1: Gratuito   | 000 | 451yzd8MoDEr565j7Nul
  // plan 2: Basico     | 101 | w8G9521rMzJH614G85h9
  // plan 5: Destacado  | 101 | 4H9In472WmV6oAuXkZy5
  // plan 6: Empresa    | 102 | vz9P7597l7n7132v4895

  checkSubscription() {
    this.subscriptions.getStatus()
      .then((plan) => {
        this.storage.planSave(plan);
        let planActiveObj = this.subscriptions.getObjectPlanByIdcod(plan.planActiveIdcod);
        let planObj = this.subscriptions.getObjectPlanByIdcod(plan.planIdcod);
        let status = this.subscriptions.getObjectStatusById(plan.statusId);
        this.doms.setHTML('user-plan-indicator', 'Plan ' + planActiveObj.title);

        let html = 'Plan Activo: ' + planActiveObj.title;
        console.log('Plan', plan);
        console.log('PlanObj', planObj);
        console.log('PlanActiveObj', planActiveObj);
        if (plan.statusActiveId == '4' && plan.nextPaymentDate) {
          html = `Plan finalizado: ${planActiveObj.title}
          <br>
          <span style="font-weight: 100; font-size:13px; color:gray">
            Servicio activo hasta: ${APICRUD.Common.ConvertDateToSpanishShort(plan.nextPaymentDate)}
          </span>`;
        } else if (plan.statusActiveId == '2' && plan.nextPaymentDate) {
          html += `
          <br>
          <span style="font-weight: 100; font-size:13px; color:gray">
            Próximo cobro: ${APICRUD.Common.ConvertDateToSpanishShort(plan.nextPaymentDate)}
          </span>`;
        }

        // Si el plan activo es distinto al plan 
        if (planActiveObj.idcod != planObj.idcod && planObj.title != 'Gratuito') {
          html += '<br><br>Plan en proceso: ' + planObj.title +
            `<br><span style="font-weight: 100; font-size:13px; color:gray">${status.description}<span>`;
        }
        this.doms.setHTML('user-plan-indicator-2', html);
        this.getTotalActivePublications()
          .then((total) => {
            this.doms.setHTML('publicaciones-activas', total + ' / ' + planActiveObj.activePublications);
            this.storage.setPublishLimit(planActiveObj.activePublications);
          })
          .catch(err => {
            console.log(err)
          })
        this.doms.removeClass('user-plan-button', 'locked');
      })
      .catch(err => {
        console.error(err);
        this.doms.setHTML('user-plan-indicator', err);
      })
  }

  // Para la ventana de venta de planes
  getPlan(_plan) {
    APICRUD.Auth.Status()
      .then(() => {
        if (_plan === 0) {
          app.userPrivateController.publish();
          // window.location.href = 'https://agrolabores.com/user/productos';
        } else {
          app.userPrivateController.account.subscriptions.showChangePlan();
        }
      })
      .catch(() => {
        app.userPrivateController.auth.showLogin();
      })
  }

  // Eliminar cuenta
  closeAccount() {
    this.modalCloseAccount = new ModalController('Eliminar mi cuenta', this.view.renderCloseAccount(), 'form-productos');
    this.modalCloseAccount.show();
  }

  async closeAccountConfirmation() {
    this.doms.setHTML('close-account-status', '');

    let email = this.doms.getValue('close-account-email-confirm');
    let phrase = this.doms.getValue('close-account-phrase-confirm');
    let user = await app.userPrivateController.auth.model.getSessionData().catch();

    if (!user) {
      return this.doms.setHTML('close-account-status', 'Debe iniciar una sesión.');
    }

    if (!user.email) {
      return this.doms.setHTML('close-account-status', 'Debe iniciar una sesión.');
    }

    if (user.email.toLowerCase() != email.trim().toLowerCase()) {
      return this.doms.setHTML('close-account-status', 'El email no coincide con el de su cuenta.');
    }

    if (phrase.toLowerCase() !== 'cerrar mi cuenta') {
      return this.doms.setHTML('close-account-status', 'La frase no concide. ');
    }

    this.doms.setHTML('close-account-status', 'Estamos cerrando su cuenta, por favor espere.');
    this.doms.addClass('close-account-btn', 'locked');

    APICRUD.Auth.CloseAccount(phrase)
      .then(() => {
        this.doms.setHTML('close-account-status', 'Se finalizó con éxito el cierre de su cuenta.');
        this.modalCloseAccount.setContent('Hemos elimiado su cuenta. Gracias por utilizar nuestra plataforma, lo esperamos pronto.<br><br>');
        app.userPrivateController.auth.logout(); app.userPrivateController.menu();
      })
      .catch((error) => {
        this.modalCloseAccount.setContent('Ocurrió un error al intentar eliminar su cuenta, por favor intentelo nuevamente en unas horas.');
        console.error(error);
      })
  }

  filterPermalinkInput(_value) {
    _value = APICRUD.Common.GetPermalink(_value);
    this.doms.setHTML('account-permalink-status', ``);
    this.setTimerCheckerPermalink(_value);
    return _value;
  }

  setTimerCheckerPermalink(_value) {
    if (this.permalinkChecker) {
      clearInterval(this.permalinkChecker);
    }
    this.doms.setHTML('account-permalink-status', LoadingDot.render());
    this.permalinkChecker = setTimeout(this.checkPermalink.bind(this), 1500, _value);
  }

  async checkPermalink(_value) {
    try {
      this.doms.setHTML('account-permalink-status', LoadingDot.render());
      if (await this.model.checkPermalink(_value) === 'available') {
        this.doms.setHTML('account-permalink-status', `<span class="cv3">Enlace permanente disponible.</span>`);
      } else {
        this.doms.setHTML('account-permalink-status', `<span class="cr">Enlace permanente no disponible.</span>`);
      }
    } catch (error) {
      console.error('checkPermalink: ', error);
      throw error;
    }
  }

}
